<template>
    <div class="container training">
        <div class="row">
            <div class="col col-3">            
                <div class="training__thumb">
                    <img v-auth-image="'/photos/'+ article.thumbnail_image_id + '?thumbnail=300'" alt="" class="" v-if="article.main_image_id" />
                </div>
                <p class="training__p training__category">{{ article.created_at }}</p>
                <h3 class="training__name">{{ article.title }}</h3>
            </div>
            <div class="col col-8 offset-md-1 training__desc">
                <h1>{{ article.title }}</h1>
                <img v-auth-image="'/photos/'+ article.main_image_id" alt="" class="" v-if="article.main_image_id" />
                <div v-html="article.content"></div>
                <table class="invoices__table" v-if="article.attachments && article.attachments.length > 0">
                    <tr>
                        <th class="align-left">Załączniki</th>
                    </tr>
                    <tr>
                        <td v-for="attachment in article.attachments" class="align-left">
                            <a :href="attachment.link" target="_blank" class="invoices__table-link">{{ attachment.original_filename }}</a>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'AdviceComponent',
    components: {
        
    },
  data () {
    return {
        pending: true,
        article: {}         
    }
  },
  mounted: function() {
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/lawAdvices/' + to.params.id
    })
    .then(response => { 
        next(vm => {
            vm.article = response.data.data.article
        })
    })
    .catch(error => next(false))
  },
  methods: {
  }
}
</script>


// WEBPACK FOOTER //
// src/app/home/advices/AdviceComponent.vue